<i18n lang='yml' src='../i18n/ManageRoles.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <fieldset v-else>
    <div class="white-bg padded margin-bottom">
      <legend>
        {{ $t('header') }}
        <button type='button' class='btn btn-sm btn-success' v-on:click='newRole'>
          <font-awesome-icon :icon="['fas', 'plus']" aria-hidden="true" />
          {{ $t('new_role') }}
        </button>
      </legend>
    </div>

    <template v-for='(role, index) in networkRoles'>
      <div class="white-bg padded margin-bottom">
        <fieldset class='network-role'>
          <input type='hidden' :name='fieldName + "[id]"' :value='role.id'>
          <role-name-and-nalbs :key='index' :permissions='permissions' :locale='locale' :role='role'
                               :fieldName='fieldName' :nalbs='availableNalbs' :roleIndex='index'
                               v-on:selectDefaultRole='selectDefaultRole'>
          </role-name-and-nalbs>

          <div class='form-group row'>
            <div class='col-sm-12 text-right'>
              <button type='button' class='btn btn-sm btn-danger' v-on:click='removeRole(index)'>
                <span class='fa fa-fw fa-times' aria-hidden='true'></span>
                {{ $t('delete_role') }}
              </button>
            </div>
          </div>
        </fieldset>
      </div>
    </template>
  </fieldset>
</template>

<script>
    import roleNameAndNalbs from './RoleNameAndNalbs.vue';
    import roleAbilities from './RoleAbilities.vue';
    import { sendAjaxRequest } from '../../../../shared/typescripts/ajax.ts'
    export default {
        props: ['locale', 'endpoint', 'fieldName'],
        components: {
            'role-name-and-nalbs': roleNameAndNalbs,
            'role-abilities': roleAbilities
        },
        data () {
            return {
                availableNalbs: [],
                networkRoles: [],
                networkRoleTemplate: {},
                permissions: {},
                loading: true
            }
        },
        mounted () {
            this.$i18n.locale = this.locale;

            sendAjaxRequest('GET', this.endpoint + '.json', 'json', {}, this.ajaxSuccess)
        },
        methods: {
            newRole: function(event) {
                // Deep copying the object here to prevent multiple unsaved roles from using the same reference
                this.networkRoles.push(JSON.parse(JSON.stringify(this.networkRoleTemplate)));
                setTimeout(function() {
                    $(event.target).closest('fieldset').find('.network-role').last()[0].scrollIntoView();
                }, 150);
            },
            removeRole: function(index) {
                if (confirm(this.$t('delete_confirm'))) {
                  if(this.networkRoles.length == 1) {
                    // Can't have 0 roles
                    alert("You can't have less than 1 role");
                  }
                  else {
                    this.networkRoles.splice(index, 1);
                  }
                }
            },
            selectDefaultRole: function(index) {
              for (let i = 0; i < this.networkRoles.length; i++) {
                  this.networkRoles[i].defaultRole = i === index;
              }
            },

            ajaxSuccess(data) {
              const self = this;
              // This is not just the list of available nalbs it actually is combined data from 
              // available nalbs, network nalbs, and top level nalbs, which is why the names appear 
              // with the top level nalb names in the UI
              self.availableNalbs = data['availableNalbs'];
              self.networkRoles = data['networkRoles'];
              self.networkRoleTemplate = data['networkRoleTemplate'];
              self.permissions = data['permissions'];
              self.loading = false;
              if(self.networkRoles.length == 0) {
                // Deep copying the object here to prevent multiple unsaved roles from using the same reference
                self.networkRoles.push(JSON.parse(JSON.stringify(self.networkRoleTemplate)));
              }
            }
        }
    }
</script>
